import * as yup from "yup";

export const pushGiftNotificationSchema = yup.object().shape({
    message: yup
        .string()
        .min(3, "محتوى الاشعار قصير جدا")
        .required("محتوى الاشعار مطلوب"),
});
